var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ColoredTag",class:{
    'tag-blue': _vm.color === 'blue',
    'tag-dark-blue': _vm.color === 'dark-blue',
    'tag-opaque-blue': _vm.color === 'opaque-blue',
    'tag-green': _vm.color === 'green',
    'tag-green-alt': _vm.color === 'green-alt',
    'tag-orange': _vm.color === 'orange',
    'tag-pink': _vm.color === 'pink',
    'tag-purple': _vm.color === 'purple',
    'tag-purple-alt': _vm.color === 'purple-alt',
    'tag-red-alt': _vm.color === 'red-alt',
  }},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }